module.exports = __webpack_public_path__ + "static/media/6.97f71839.jpg";